import { useNavigate } from 'react-router-dom';
import { ArrowShortLeft } from '@shared/assets/index.ts';
import { IconButton } from '@shared/ui/index.ts';

type PT = {
  onClick?: () => void;
};
export const PageBackButton = ({ onClick }: PT) => {
  const nav = useNavigate();
  return (
    <IconButton type="button" onClick={onClick ? onClick : () => nav(-1)}>
      <ArrowShortLeft />
    </IconButton>
  );
};
